(function () {
  'use strict';

  function init(selector) {
    if (selector.dataset.gsPrintMethodInit === '1') return;
    selector.dataset.gsPrintMethodInit = '1';

    var inputs = Array.prototype.slice.call(selector.querySelectorAll('[data-gs-print-method-input]'));
    var options = selector.querySelector('[data-gs-print-method-options]');
    var desktopPreview = selector.querySelector('[data-gs-print-method-desktop-preview]');
    var comparisonButtons = Array.prototype.slice.call(selector.querySelectorAll('[data-gs-print-method-comparison]'));
    var status = selector.querySelector('[data-gs-print-method-status]');
    var mobileQuery = window.matchMedia('(max-width: 560px)');

    function methodKind(input) {
      return input && input.dataset.gsPrintMethodKind === 'vivid' ? 'vivid' : 'standard';
    }

    function updateUi(input, announce) {
      var kind = methodKind(input);
      selector.dataset.gsSelectedMethod = kind;
      selector.dataset.gsPreviewMethod = kind;
      comparisonButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.gsPrintMethodComparison === kind));
      });
      if (announce && status) {
        status.textContent = '';
        window.requestAnimationFrame(function () {
          status.textContent = input.value + ' selected. Prices updated.';
        });
      }
    }

    function showDesktopPreview(kind) {
      if (!desktopPreview || mobileQuery.matches) return;
      selector.dataset.gsPreviewMethod = kind;
      desktopPreview.hidden = false;
    }

    function hideDesktopPreview() {
      if (desktopPreview) desktopPreview.hidden = true;
    }

    var checkedInput = inputs.filter(function (input) { return input.checked; })[0];
    var vividInput = inputs.filter(function (input) {
      return methodKind(input) === 'vivid' && !input.disabled;
    })[0];
    var initial = checkedInput || vividInput || inputs[0];
    if (initial) updateUi(initial, false);

    selector.querySelectorAll('[data-gs-print-method-option]').forEach(function (option) {
      var kind = option.dataset.gsPrintMethodOption === 'vivid' ? 'vivid' : 'standard';
      option.addEventListener('pointerenter', function () { showDesktopPreview(kind); });
      option.addEventListener('focusin', function () { showDesktopPreview(kind); });
    });

    if (options) {
      options.addEventListener('pointerleave', hideDesktopPreview);
      options.addEventListener('focusout', function () {
        window.requestAnimationFrame(function () {
          if (!options.contains(document.activeElement)) hideDesktopPreview();
        });
      });
    }

    selector.addEventListener('change', function (event) {
      var input = event.target.closest && event.target.closest('[data-gs-print-method-input]');
      if (input && input.checked) updateUi(input, true);
    });

    comparisonButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var kind = button.dataset.gsPrintMethodComparison === 'vivid' ? 'vivid' : 'standard';
        var input = inputs.filter(function (candidate) { return methodKind(candidate) === kind; })[0];
        if (input && !input.checked) input.click();
      });
    });

    if (!checkedInput && vividInput) vividInput.click();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-gs-print-method]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
